import axios from '@client/lib/axios'

export const fetch = () => {
  return axios({
    method: 'get',
    url: '/api/2/session'
  })
}
